import { DataSourceExecutionEvent } from "@mcleod/components";
import { AutogenLayoutWireHistory } from "./autogen/AutogenLayoutWireHistory";
import {FuelInterface} from "@mcleod/integrations";

export class WireHistory extends AutogenLayoutWireHistory {

    onLoad(): void | Promise<void> {
        this.addLayoutDataLoadListener(() => {
            this.setFieldVisibility();
        })
    }

    resetComponentsVisibility() {
        this.textboxFuelCardId.visible = false;
        this.textboxWireContractTch.visible = false;
        this.textboxIfuelQuikqAssetId.visible = false;
        this.textboxSubaccountId.visible = false;
    }

    /** This is an event handler for the afterExecution event of sourceUnpostedWire. */
    sourceUnpostedWireAfterExecution(event: DataSourceExecutionEvent) {
        this.setFieldVisibility();
    }

    setFieldVisibility() {
        const wireType = this.activeRow?.get("wirecode.wire_type");
        const vendor = this.activeRow?.get("wirecode.fuel_interface_id");
        this.resetComponentsVisibility();

        if (this.activeRow !== null) {
            if (vendor == FuelInterface.COMDATA || vendor == FuelInterface.FLEETONE) {
                this.textboxSubaccountId.visible = true;
            } else if (vendor == FuelInterface.QUIKO) {
                this.textboxIfuelQuikqAssetId.visible = true;
            } else if (vendor == FuelInterface.EFS) {
                this.textboxWireContractTch.visible = true;
            }

            if (wireType == 'A') {
                this.textboxFuelCardId.visible = true;
            }
        }
    }
}
